import Button from '@ergeon/core-components/exports/Button.ts';
import Card from '@ergeon/core-components/exports/Card.ts';

interface CancelledNoticeProps {
  isClient: boolean;
  hostTitle: string;
  currentMeetingUrl: string | null;
}

const TEXT = 'paragraph-3 text-gray-700 dark:text-gray-200';

// Most customers here come late to a visit marked a no-show, which has no next
// visit, so nothing promises them a new time.
const customerNextStep = (hostTitle: string, currentMeetingUrl: string | null) => {
  if (!currentMeetingUrl) {
    return <p className={TEXT}>Your {hostTitle.toLowerCase()} may not join this call.</p>;
  }

  // A full page load on purpose: the meeting query is not keyed by hash, so an
  // in-app navigation would keep this cancelled meeting's channel and token.
  return (
    <>
      <p className={TEXT}>Your next video visit has its own link.</p>
      <Button
        asAnchor flavor="primary" href={currentMeetingUrl} isFullWidth
        size="large">
        Go to your next video visit
      </Button>
    </>
  );
};

// A notice rather than a block: a call does now and then still happen after a
// cancel, and the room stays open for it.
const CancelledNotice = ({ isClient, hostTitle, currentMeetingUrl }: CancelledNoticeProps) => (
  <Card
    className="flex-col gap-2 px-5 py-4"
    flavor="warning"
    rounded="medium"
    tag="section">
    <h2 className="paragraph-2 font-bold text-gray-900 dark:text-gray-100">
      This appointment was cancelled
    </h2>
    {isClient ?
      customerNextStep(hostTitle, currentMeetingUrl) :
      <p className={TEXT}>The customer can still join this call.</p>}
  </Card>
);

export default CancelledNotice;
